import {
  createElement, FunctionComponent, ComponentClass
} from 'react';
// eslint-disable-next-line react/no-deprecated
import { createRoot } from 'react-dom/client';

type GenericComponent<P> = FunctionComponent<P> | ComponentClass<P>;

const renderReact = <P extends object>(component: GenericComponent<P>, elementId: string): void => {
  if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', () => renderReactInternal(component, elementId));
  } else {
    // `DOMContentLoaded` has already fired
    renderReactInternal(component, elementId);
  }
};

const renderReactInternal = <P extends object>(component: GenericComponent<P>, elementId: string): void => {
  const div = document.getElementById(elementId);

  if (!div) return;

  const { reactProps } = div.dataset;
  const props = reactProps ? JSON.parse(reactProps) : {};

  createRoot(div).render(createElement(component, props));
};

export default renderReact;
